"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeI18n = exports.useTranslation = void 0;
const tslib_1 = require("tslib");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
const i18next_1 = tslib_1.__importDefault(require("i18next"));
const i18next_browser_languagedetector_1 = tslib_1.__importDefault(require("i18next-browser-languagedetector"));
const react_i18next_1 = require("react-i18next");
const common_json_1 = tslib_1.__importDefault(require("./locales/en/common.json"));
const identity_json_1 = tslib_1.__importDefault(require("./locales/en/identity.json"));
const common_json_2 = tslib_1.__importDefault(require("./locales/fr/common.json"));
const identity_json_2 = tslib_1.__importDefault(require("./locales/fr/identity.json"));
var react_i18next_2 = require("react-i18next");
Object.defineProperty(exports, "useTranslation", { enumerable: true, get: function () { return react_i18next_2.useTranslation; } });
const builtInResources = {
    en: {
        common: common_json_1.default,
        identity: identity_json_1.default,
    },
    fr: {
        common: common_json_2.default,
        identity: identity_json_2.default,
    },
};
function initializeI18n(options = {}) {
    var _a, _b;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        options.resources = deepmerge_1.default(builtInResources, (_a = options.resources) !== null && _a !== void 0 ? _a : {});
        const resourcesLanguages = Object.keys(options.resources);
        const supportedLngs = [options.lng, options.fallbackLng, ...resourcesLanguages]
            .filter((language) => !!language)
            .filter((value, index, self) => self.indexOf(value) === index);
        yield i18next_1.default
            // detect user language
            // learn more: https://github.com/i18next/i18next-browser-languageDetector
            .use(i18next_browser_languagedetector_1.default)
            // pass the i18n instance to react-i18next.
            .use(react_i18next_1.initReactI18next)
            // init i18next
            // for all options read: https://www.i18next.com/overview/configuration-options
            .init(Object.assign({ fallbackLng: (_b = Object.keys(resourcesLanguages)[0]) !== null && _b !== void 0 ? _b : undefined, debug: false, interpolation: {
                escapeValue: false,
            }, nsSeparator: "::", keySeparator: "..", supportedLngs, defaultNS: "common" }, options));
        return i18next_1.default;
    });
}
exports.initializeI18n = initializeI18n;
//# sourceMappingURL=I18n.js.map